import { gql } from "@apollo/client";

export const DISMISS_VETCOVE_REDIRECT = gql`
  mutation DismissVetCoveRedirect {
    dismissVetCoveRedirect
  }
`;
